import { Api, Category } from '@firmable/contracts';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import * as QueryContract from '@web/contracts/Query';
import axios from 'axios';

type ContextQueryResponse = Record<
  QueryContract.Context.Company.ContextType,
  Record<string, QueryContract.Context.Company.Item>
>;

export interface Failure {
  message: string;
}

export type ContextApiResponse = {
  success: true;
  records: Api.Context.ContextResponse;
};

type QueryParams = {
  category: Category;
  countries?: AvailableCountries[];
  enabled?: boolean;
};

/**
 * React Query hook to fetch company details
 * @returns ContextApiResponse | undefined
 */
const useRegister = ({ category, countries, enabled = true }: QueryParams) => {
  return useQuery<ContextQueryResponse, Failure>({
    queryKey: [Query.SearchKeys['register'], { category, countries }],
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: false,
    enabled,
    queryFn: async () => {
      const { data } = await axios.post<ContextApiResponse>(
        `${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/register/${category}`,
        {
          countries,
        },
      );
      return {
        register: data.records.register,
      };
    },
  });
};

export { useRegister };
